'use strict';
/*global s7viewers*/

function init(videoViewerComponents) {
  [].forEach.call(videoViewerComponents, (element) => {
    new s7viewers.VideoViewer({
      "containerId": element.getAttribute("id"),
      "params" : {
        "asset" : "JohnLewis/" + element.getAttribute("data-asset"),
        "serverurl" : "https://johnlewis.scene7.com/is/image/",
        "contenturl": "https://johnlewis.scene7.com/skins/",
        "config": "Scene7SharedAssets/Universal_HTML5_Video",
        "videoserverurl": "https://johnlewis.scene7.com/is/content/",
        "posterimage": "JohnLewis/" + element.getAttribute("data-poster-image"),
        "smoothing": "1"
      },
      "handlers":{
        "trackEvent": function(objID, compClass, instName, timeStamp, eventInfo) {
          document.body.dispatchEvent(
            new CustomEvent(
              'scene7VideoEvent',
              {
                "detail" : {
                  "id": element.getAttribute("data-asset"),
                  "eventInfo": eventInfo
                }
              }
            )
          );
        }
      }
    }).init();
  });
}

init(document.querySelectorAll('.s7-video-viewer') || []);
